module.exports = __webpack_public_path__ + "static/media/vacuolo.f619a13c.mp3";